
export default {
  routeExtras: {
    'extras': 'További információk az útvonalról',
    'extraInfo': 'További információk',
    'value': 'Érték',
    'clickToHighlightOnMap': 'Kattintson a térképen való megjelenítéshez',
    'showAllOnMap': 'Az összes megjelenítése az térképen'
  }
}
